module.exports = __webpack_public_path__ + "static/media/eea-award.8a53bd5d.png";